import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';

/**
 * @param {string} domain
 * @param {string} accessToken
 * @param {string} promocode
 * @return {Promise<void>}
 */
export async function spasiboSberbankActivate(domain, accessToken, promocode) {
    const form = new FormData();
    form.append('promocode', promocode);

    await profileRequest(domain, accessToken).post('/sberbank/spasibo', form);
}

